const addMessageTimelineActionStr = {
  toastr: 'Added Message'
};

export default addMessageTimelineActionStr;
